import * as Client from '@avcan/prismic/clients/accidents'
import * as AccidentUtils from '@avcan/utils/products/accident'

export async function accidents(locale) {
    const accidents = await Client.getAll(locale)

    return AccidentUtils.createFeatureCollection(accidents)
}
